import { Pickaxe, Gamepad2, ShoppingBag, Users, User } from "lucide-react";
import { PAGE_NAME } from "../types";

/**
 * Four tabs, one intent each:
 *  Mine  — claim the 2h grant (Home)
 *  Earn  — ads, games, spin, contest
 *  Shop  — everything that costs Pi
 *  Invite — referrals
 * Profile lives behind the avatar in the top bar.
 */
export const MOBILE_NAV_LINKS = [
  { href: PAGE_NAME.HOME, name: "Mine", icon: Pickaxe },
  { href: PAGE_NAME.EARN, name: "Earn", icon: Gamepad2 },
  { href: PAGE_NAME.SHOP, name: "Shop", icon: ShoppingBag },
  { href: PAGE_NAME.INVITE_USERS, name: "Invite", icon: Users },
];

export const DESKTOP_NAV_LINKS = [
  ...MOBILE_NAV_LINKS,
  { href: PAGE_NAME.PROFILE, name: "Profile", icon: User },
];

/** Routes rendered without the app chrome (no top bar, no tabs). */
export const EXCLUDED_ROUTES: string[] = ["/", PAGE_NAME.LOGIN];
